import {WeChatApplicationType} from "../enums/WeChatApplicationType";

export class WeChatApplicationDto {
    keyId: string = '';
    id: string = '';
    name: string = '';
    appId: string = '';
    appSecret: string = '';
    type: string = WeChatApplicationType.Enum.Official;
    remarks: string = '';
}